import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73a20c8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-box" }

import { ref, onBeforeMount, inject } from 'vue'
import SummaryLeads from './components/SummaryLeads.vue'
import LeadDeliveryEchart from './components/LeadDeliveryEchart.vue'
import LeadConversion from './components/LeadConversion.vue'
import RegionDistributionChart from './components/RegionDistributionEchart.vue'
import InvalidReasonEchart from './components/InvalidReasonEchart.vue'
import { zbuGetDataSummary } from '@/api/marketing/index'
enum Subdomain {
  Fbu = 'fbu',
  Lbu = 'lbu'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const subdomain = inject<Subdomain>('subdomain') || Subdomain.Fbu

const spinning = ref(false)
const dataSummary = ref<any>({})
const getSummaryData = () => {
  spinning.value = true
  zbuGetDataSummary()
    .then((res: any) => {
      if (subdomain === Subdomain.Lbu) {
        res.data.transVos = res.data.transVos.filter((item: any) => item.clueType !== 5)
      }
      dataSummary.value = res.data
    })
    .catch(() => {
      dataSummary.value = {}
    })
    .finally(() => {
      spinning.value = false
    })
}

onBeforeMount(getSummaryData)

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SummaryLeads, {
      value: dataSummary.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataSummary).value = $event))
    }, null, 8, ["value"]),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(LeadDeliveryEchart, { title: "线索投放情况" })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(LeadConversion, {
              title: "线索转化",
              value: dataSummary.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataSummary).value = $event)),
              spinning: spinning.value
            }, null, 8, ["value", "spinning"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(RegionDistributionChart, {
              title: "客户区域分布",
              value: dataSummary.value,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataSummary).value = $event)),
              spinning: spinning.value
            }, null, 8, ["value", "spinning"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(InvalidReasonEchart, { title: "无效原因分析" })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})